import Navigation from '../Navigation';

function AppBar() {
  return (
    <header>
      <Navigation />
    </header>
  );
}

export default AppBar;
